<template>
    <div class="zl-navigation">
      <div class="zl-header">
        <div class="zl-header-inner">
<!--          <div class="zl-header-img"></div>-->
          <img class="zl-header-img" src="https://wpimg.wallstcn.com/f778738c-e4f8-4870-b634-56703b4acafe.gif?imageView2/1/w/80/h/80">
          <div class="zl-header-text">
            {{userName}}
          </div>
        </div>
      </div>
       <div :class="acitveMenu==1?'zl-navigation-p active1':'zl-navigation-p'" @click="changeShow(true,1)">
         <!-- <span class="el-icon-menu zl-icon"></span> -->
         <div class="icon1"></div>
         <span style="font-size: 13px;margin-top:5px;">章节</span>
       </div>
       <div :class="acitveMenu==2?'zl-navigation-p active2':'zl-navigation-p'" @click="changeShow(false,2)">
         <!-- <span class="el-icon-headset zl-icon"></span> -->
         <div class="icon2"></div>
         <span style="font-size: 13px;margin-top:5px;">疑答</span>
       </div>
       <div :class="acitveMenu==3?'zl-navigation-p active3':'zl-navigation-p'" @click="changeShow(false,3)">
         <!-- <span class="el-icon-edit-outline zl-icon"></span> -->
         <div class="icon3"></div>
         <span style="font-size: 13px;margin-top:5px;">笔记</span>
       </div>
      <!-- <div class="zl-navigation-sidebar" :style="{width:isShow?'250px':'0px'}">
        <zl-sidebar
          :courseId="courseId"
          :subjectId="subjectId"
          @handleTreeNodeClick="handleTreeNodeClick"
          isShow
        ></zl-sidebar>
      </div> -->
      <div v-if="isShow" class="dialogMask" @click="isShow = false"></div>
    </div>
</template>

<script>
  import zlSidebar from "../../component/zl-sidebar-show"; // 目录树
    export default {
      name: "zl-navigation",
      props: {
        leftMenuShow:{
          type:Boolean,
          default:false,
        },
      },
      data(){
          return {
            courseId:sessionStorage.getItem('courseId'),
            subjectId:sessionStorage.getItem('subjectId'),
            isShow:false,
            userName:sessionStorage.getItem('loginName'),
            acitveMenu:1
          }
      },
      components:{
        zlSidebar
      },
      methods:{
        // handleTreeNodeClick(item){
        //   this.$emit('handleTreeNodeClick', item);
        // }
        changeShow(bol,ind){
          this.acitveMenu = ind
          this.$emit('setMenuIndex', ind);
          if(ind === 1){
              this.$emit('changeShow', !this.leftMenuShow);
          }else{
            this.$emit('changeShow', bol);
          }
        }
      },
      mounted(){
        //测试用
        this.$emit('changeShow', true);
      }
    }
</script>

<style scoped lang="scss">
.zl-navigation{
  user-select: none;
  width: 80px;
  /*height: 100%;*/
  background-color: #FFFFFF;
  position: relative;
  margin-right: 2px;
  box-shadow: 0px 2px 3px 0px rgba(0,0,0,0.5);
  .zl-header{
    display: flex;
    flex-direction: column;
    margin-top: 30px;
    margin-bottom: 75px;
    .zl-header-inner{
      display: flex;
      flex-direction: column;
      align-items: center;
      // min-height: 60px;
      .zl-header-img{
        width: 40px;
        height: 40px;
        border-radius: 40px;
      /*  background: url(../../../assets/image/learnmodel/head.png)no-repeat center /100%;*/
      }
      .zl-header-text{
        margin-top: 5px;
        font-size: 10px;
        color: #333333;
        line-height: 14px;
      }
    }
  }
  .zl-navigation-p{
    width: 40px;
    margin: 40px 20px 0 20px;
    text-align: center;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    align-items: center;
    .icon1{
      width: 23px;
      height: 27px;
      background: url(../../../assets/image/learnmodel/article1.png)no-repeat center/100%;
      &:hover{
        background: url(../../../assets/image/learnmodel/article.png)no-repeat center/100%;
      }
    }
    .icon2{
      width: 27px;
      height: 27px;
      background: url(../../../assets/image/learnmodel/group1.png)no-repeat center/100%;
      &:hover{
        background: url(../../../assets/image/learnmodel/group.png)no-repeat center/100%;
      }
    }
    .icon3{
      width: 27px;
      height: 27px;
      background: url(../../../assets/image/learnmodel/fill1.png)no-repeat center/100%;
      &:hover{
        background: url(../../../assets/image/learnmodel/fill.png)no-repeat center/100%;
      }
    }
    .zl-icon{
      font-size: 25px;
      display: block;
      margin-bottom: 4px;
    }
     &:hover{
       color: #2A66FE;
     }
  }
  .active1{
    color: #2A66FE;
    .icon1{
      background: url(../../../assets/image/learnmodel/article.png)no-repeat center/100%!important;
    }
  }
  .active2{
    color: #2A66FE;
    .icon2{
      background: url(../../../assets/image/learnmodel/group.png)no-repeat center/100%;
    }
  }
  .active3{
    color: #2A66FE;
    .icon3{
      background: url(../../../assets/image/learnmodel/fill.png)no-repeat center/100%;
    }
  }
  .zl-navigation-sidebar{
    position: absolute;
    width: 200px;
    overflow: hidden;
    top: 0px;
    left: 50px;
    padding: 30px 0px;
    height: calc(100% - 60px) ;
    background: #f6f6f6;
    z-index: 200;
    transition: all 0.3s ease;
  }
  .dialogMask{
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    z-index: 199;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/new_learning_module/components/zl-navigation.vue